import {makeStyles} from "tss-react/mui";

export const useLayoutStyles = makeStyles()((theme) => ({
  layout: {
    display: "flex",
    justifyContent: "center",
    minHeight: "100vh",
    width: "100%",
    background: theme.palette.background.default,
  },
  logo: {
    height: 50,
    width: 200,
    margin: "auto 0",
    marginTop: "5px",
    backgroundImage: `url(${theme.palette.logo})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
  },
}));
